import { IUseTokensStore } from '@/src/store';
import { Decimals } from '@/src/types';
import { TOKEN_GOV_CS, TOKEN_GOV_TN_STR } from '../../utils/constants';
import { strToHex } from '../../lib/MayzSmartDB';

//----------------------------------------------------------------------

export function showADA_Amount(tokensStore: IUseTokensStore, amount: bigint | number | undefined, swRounded: boolean = false, showDecimals: Decimals = 0, adaUsdPrice?: number): string {
    return tokensStore.showTokenWithAmount(amount, '', '', swRounded, showDecimals, adaUsdPrice);
}

export function showADA_Amount_NotRounded(tokensStore: IUseTokensStore, amount: bigint | number | undefined, adaUsdPrice?: number): string {
    return showADA_Amount(tokensStore, amount, false, undefined, adaUsdPrice);
}

export function showADA_Amount_Rounded(tokensStore: IUseTokensStore, amount: bigint | number | undefined, adaUsdPrice?: number): string {
    return showADA_Amount(tokensStore, amount, true, 2, adaUsdPrice);
}

//----------------------------------------------------------------------

export function showTokenGov_Amount(tokensStore: IUseTokensStore, amount: bigint | number | undefined, swRounded: boolean = false, showDecimals: Decimals = 0): string {
    return tokensStore.showTokenWithAmount(amount, TOKEN_GOV_CS, strToHex(TOKEN_GOV_TN_STR), swRounded, showDecimals);
}

export function showTokenGov_Amount_NotRounded(tokensStore: IUseTokensStore, amount: bigint | number | undefined): string {
    return showTokenGov_Amount(tokensStore, amount, false);
}

export function showTokenGov_Amount_Rounded(tokensStore: IUseTokensStore, amount: bigint | number | undefined): string {
    return showTokenGov_Amount(tokensStore, amount, true, 2);
}

//----------------------------------------------------------------------

export function showToken_Amount(
    tokensStore: IUseTokensStore,
    amount: bigint | number | undefined,
    CS: string,
    TN_Hex: string,
    swRounded: boolean = false,
    showDecimals: Decimals = 0
): string {
    return tokensStore.showTokenWithAmount(amount, CS, TN_Hex, swRounded, showDecimals);
}

export function showToken_Amount_NotRounded(tokensStore: IUseTokensStore, amount: bigint | number | undefined, CS: string, TN_Hex: string): string {
    return showToken_Amount(tokensStore, amount, CS, TN_Hex, false);
}

export function showToken_Amount_Rounded(tokensStore: IUseTokensStore, amount: bigint | number | undefined, CS: string, TN_Hex: string): string {
    return showToken_Amount(tokensStore, amount, CS, TN_Hex, true, 2);
}

//----------------------------------------------------------------------

export function showToken_Price(tokensStore: IUseTokensStore, CS: string, TN_Hex: string, swRounded: boolean = false, showDecimals: Decimals = 0): string {
    return tokensStore.showTokenPrice(CS, TN_Hex, swRounded, showDecimals);
}

export function showToken_Price_NotRounded(tokensStore: IUseTokensStore, CS: string, TN_Hex: string): string {
    return showToken_Price(tokensStore, CS, TN_Hex, false);
}

export function showToken_Price_Rounded(tokensStore: IUseTokensStore, CS: string, TN_Hex: string): string {
    return showToken_Price(tokensStore, CS, TN_Hex, true, 2);
}

//----------------------------------------------------------------------

export function showToken_Price_MultipliedByAmount(
    tokensStore: IUseTokensStore,
    amount: bigint | number | undefined,
    CS: string,
    TN_Hex: string,
    swRounded: boolean = false,
    showDecimals: Decimals = 0,
    decimalsInAmount: Decimals = 0
): string {
    return tokensStore.showTokenPriceMultipliedByAmount(amount, CS, TN_Hex, swRounded, showDecimals, decimalsInAmount);
}

export function showToken_Price_MultipliedByAmount_NotRounded(
    tokensStore: IUseTokensStore,
    amount: bigint | number | undefined,
    CS: string,
    TN_Hex: string,
    decimalsInAmount: Decimals = 0
): string {
    return showToken_Price_MultipliedByAmount(tokensStore, amount, CS, TN_Hex, false, undefined, decimalsInAmount);
}

export function showToken_Price_MultipliedByAmount_Rounded(
    tokensStore: IUseTokensStore,
    amount: bigint | number | undefined,
    CS: string,
    TN_Hex: string,
    decimalsInAmount: Decimals = 0
): string {
    return showToken_Price_MultipliedByAmount(tokensStore, amount, CS, TN_Hex, true, 2, decimalsInAmount);
}

//----------------------------------------------------------------------
